import { type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { kebabCase } from 'lodash';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MenuProvider, dropdownPrimitives } from '@/components/menu-renderer';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const DropdownSelect = (props: { title: string; children: ReactNode; menuClassName?: string }) => {
  const { title, children, menuClassName } = props;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="main-toolbar"
          className="mx-1 h-auto! min-h-auto! gap-x-1 p-1 text-xs font-bold text-text-gray!"
          icon={ChevronDown}
          iconPosition="right"
          iconClassName="icon-5"
          data-cy={`dropdown-select-${kebabCase(title)}`}
        >
          {title}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className={cn('w-40', menuClassName)} align="start" sideOffset={10}>
        <MenuProvider primitives={dropdownPrimitives}>{children}</MenuProvider>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
